import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { GRENADA_PARISHES } from '../utils/constants'; 

function OffenseForm({ onSubmit, onCancel, error }) {
  const [formData, setFormData] = useState({
    case_number: '',
    offense_type: '',
    location: '',
    incident_report: '',
    arresting_officer: '',
  });
  const [arrestDate, setArrestDate] = useState(new Date());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const submissionData = {
      ...formData,
      arrest_date: arrestDate,
    };
    onSubmit(submissionData);
  };

  return (
    <div className="card p-6 mt-4 bg-slate-50 border-gold">
      <h3 className="text-xl font-bold text-slate-800 mb-4">Add New Offense</h3>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Case Number</label>
            <input type="text" name="case_number" value={formData.case_number} onChange={handleChange} required />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Arrest Date</label>
            <DatePicker selected={arrestDate} onChange={(date) => setArrestDate(date)} className="w-full" dateFormat="dd/MM/yyyy" required />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Offense Type</label>
            <input type="text" name="offense_type" value={formData.offense_type} onChange={handleChange} required />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Parish</label>
              <select name="parish" value={formData.parish} onChange={handleChange} required>
                 <option value="">-- Select a Parish --</option>
                  {GRENADA_PARISHES.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Location</label>
            <input type="text" name="location" value={formData.location} onChange={handleChange} />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-slate-700 mb-1">Arresting Officer</label>
            <input type="text" name="arresting_officer" value={formData.arresting_officer} onChange={handleChange} />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-slate-700 mb-1">Incident Report</label>
            <textarea name="incident_report" value={formData.incident_report} onChange={handleChange} />
          </div>
        </div>

        {error && <p className="text-red-500 text-center mt-4">{error}</p>}
        
        <div className="flex justify-end gap-4 pt-4 mt-6 border-t border-slate-200">
          <button type="button" onClick={onCancel} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-4 rounded-lg">Cancel</button>
          <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg">Save Offense</button>
        </div>
      </form>
    </div>
  );
}

export default OffenseForm;